<template>
	<div>
		<router-view />
	</div>
</template>

<script>
export default {
  name: 'App',
  mounted() {

  },
  watch: {
    $route(to) {
      document.title = to.meta.title || 'Click Gestão | A gestão de seu negócio em um click';
    },
  },
};
</script>
